var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2281 0.085073C23.1241 -0.0044639 22.9762 -0.025237 22.8509 0.0318719L0.201942 10.3685C0.0800076 10.4242 0.00148657 10.5437 2.0844e-05 10.6757C-0.00144488 10.8078 0.0744937 10.9289 0.195242 10.9871L6.60486 14.0769C6.7224 14.1336 6.86255 14.1208 6.96752 14.0437L13.1994 9.46855L8.30712 14.4116C8.23733 14.4821 8.20173 14.5787 8.20941 14.6768L8.69652 20.908C8.70734 21.046 8.80156 21.1641 8.9355 21.2073C8.97131 21.2189 9.00809 21.2245 9.04445 21.2245C9.14419 21.2245 9.24121 21.1825 9.3087 21.1057L12.7107 17.2334L16.9163 19.2072C17.0076 19.25 17.1133 19.2518 17.206 19.2122C17.2988 19.1725 17.3694 19.0953 17.3997 19.0005L23.3309 0.445483C23.3723 0.315908 23.3319 0.17461 23.2281 0.085073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.570988090c70f66d421fba7874c704d5.svg";
export { ForwardRef as ReactComponent };